import React from 'react';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { Accordion, Panel } from '../accordion';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import {
  questionAccordion,
  questionContainer,
} from './faq-styles';

type TProps = {
  elementBlock: string;
  title: string;
  id?: string;
  questions: {
    question: string;
    answer: string;
  }[];
}

export const Faq: React.FC<TProps> = ({ elementBlock, title, questions, id }) => {

  if (!questions?.length) {
    return null;
  }

  /**
   * Обработчик нажатия на колапс панели
   */
  const handlePanelClick = (question: string, order: number) => (_: string, isOpen: boolean) => {
    if (!isOpen) {
      analyticsUtils.clickButtonEvent(
        elementBlock,
        title,
        `${question.slice(0, 100)} / ${order}`
      );
    }
  };

  return (
    <Section {...(id ? { id } : {})} itemScope itemType="https://schema.org/FAQPage">
      <SectionSubTitle margin="m">{title}</SectionSubTitle>
      <Accordion className={questionAccordion}>
        {
          questions.map(({ question, answer }, index) => (
            <Panel
              name={`${question}-${index}`}
              key={createElementKey('question', index)}
              onClick={handlePanelClick(question, index + 1)}
              title={question}>
              <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                <div className={questionContainer} itemProp="text" dangerouslySetInnerHTML={{ __html: answer }} />
              </div>
            </Panel>
          ))
        }
      </Accordion>
    </Section>
  );
};
